import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetproductionvolumespage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetProductionVolumesPage } = await import(
        /* webpackChunkName: "BudgetProductionVolumesPage" */
        '../../../components/pages/private/BudgetProductionVolumesPage'
      )
      return {
        default: BudgetProductionVolumesPage,
      }
    })}
    exact
    key={paths.productionVolumesImport}
    path={paths.productionVolumesImport}
  />,
]
